<template>
  <div
    v-if="value"
    class="infoBlock"
  >
    <div
      class="label"
      :data-automation="dataAutomation + '-label'"
    >
      {{ label }}
    </div>
    <div :data-automation="dataAutomation + '-value'">
      {{ value.count }}
    </div>
    <PercentileBar
      v-if="value.percentile"
      :percentile="value.percentile"
    />
  </div>
</template>

<script>

import PercentileBar from './PercentileBar'

export default {
  name: 'InfoBlockDownloads',
  components: {
    PercentileBar,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      type: Object,
    },
    dataAutomation: {
      type: String,
      required: true,
      default: '',
    },
  },
}

</script>
